// @ts-check
import { FETCH_DIVISION_DETAILS_START, FETCH_DIVISION_DETAILS_SUCCESS, FETCH_DIVISION_DETAILS_FAIL } from "./actions";

const initialState = {
  division: null,
  isFetching: false,
  hasError: false,
};

export default function divisionDetails(state = initialState, action) {
  switch (action.type) {
    case FETCH_DIVISION_DETAILS_START:
      return {
        ...state,
        isFetching: true,
      };

    case FETCH_DIVISION_DETAILS_SUCCESS:
      return {
        ...state,
        division: action.payload,
        isFetching: false,
        hasError: false,
      };

    case FETCH_DIVISION_DETAILS_FAIL:
      return {
        ...state,
        division: null,
        isFetching: false,
        hasError: true,
      };

    default:
      return state;
  }
}
